import { render, staticRenderFns } from "./inviteExternalContact.vue?vue&type=template&id=20aed320&scoped=true"
import script from "./inviteExternalContact.vue?vue&type=script&lang=js"
export * from "./inviteExternalContact.vue?vue&type=script&lang=js"
import style0 from "./inviteExternalContact.vue?vue&type=style&index=0&id=20aed320&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aed320",
  null
  
)

export default component.exports